var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bulletin-container" }, [
    _c(
      "h1",
      [
        _vm._v("\n    Dokumentumok\n\n    "),
        _vm.loading ? _c("a-icon", { attrs: { type: "loading" } }) : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-documents-categories" },
      [
        _c(
          "a-button",
          {
            attrs: {
              type: "default",
              disabled:
                _vm.selectedCategoryIds.length === 0 &&
                (_vm.search === undefined || _vm.search.length === 0)
            },
            on: {
              click: function($event) {
                _vm.selectedCategoryIds = []
                _vm.search = undefined
              }
            }
          },
          [_vm._v("\n      Összes\n    ")]
        ),
        _c(
          "div",
          { staticClass: "bulletin-documents-categories-buttons" },
          _vm._l(_vm.categories, function(category) {
            return _c(
              "a-button",
              {
                key: category.id,
                attrs: {
                  type:
                    _vm.selectedCategoryIds.indexOf(category.id) !== -1
                      ? "primary"
                      : "default"
                },
                on: {
                  click: function($event) {
                    return _vm.toggleCategory(category.id)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
            )
          }),
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-documents-search" },
      [
        _c("a-input", {
          attrs: { placeholder: "Keresés" },
          model: {
            value: _vm.search,
            callback: function($$v) {
              _vm.search = $$v
            },
            expression: "search"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-documents-container" },
      _vm._l(_vm.documents, function(file) {
        return _c("BulletinFileComponent", {
          key: file.id,
          attrs: { file: file }
        })
      }),
      1
    ),
    _vm.total > _vm.limit
      ? _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("a-pagination", {
              attrs: {
                total: _vm.total,
                "page-size": _vm.limit,
                "show-less-items": ""
              },
              model: {
                value: _vm.current,
                callback: function($$v) {
                  _vm.current = $$v
                },
                expression: "current"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }